import {
	useInfiniteQuery,
	useQuery,
	type UseQueryOptions,
} from '@tanstack/react-query';
import type {
	LWApiPublicSupportRequestListParamsRawI,
	LWApiPublicSupportRequestListResultRawI,
} from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SUPPORT_REQUEST_LIST_QUERY_KEY = '/support/request/list';

/**
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestListParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions} options
 */
const useSupportRequestList = (
	params: LWApiPublicSupportRequestListParamsRawI,
	options?: UseQueryOptions<LWApiPublicSupportRequestListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [SUPPORT_REQUEST_LIST_QUERY_KEY, params],
		queryFn: () => api.support.request.apiRaw.list(params),
		...options,
	});

export const useInfiniteSupportRequestList = (
	params: Omit<LWApiPublicSupportRequestListParamsRawI, 'page_num'>,
) =>
	useInfiniteQuery({
		queryKey: [SUPPORT_REQUEST_LIST_QUERY_KEY, params],
		queryFn: ({ pageParam }) =>
			api.support.request.apiRaw.list({ ...params, page_num: pageParam || 1 }),
		getNextPageParam: (lastPage) => {
			const { page_num: lastPageNum, page_total: pageTotal } = lastPage;

			if (lastPageNum === pageTotal) return undefined;
			return lastPageNum + 1;
		},
	});

export default useSupportRequestList;
